import axios from "../Axios/Default";
import { handleResponse } from "../Utils/Utils";

export const getLanguages = (_params, onSuccess, onError) => {
    // _params.orders = 'language_name:asc';
    const response = axios.get(`v1/admin/language`, { params: _params });
    return handleResponse(response, onSuccess, onError);
}

export const deleteLanguage = (language_code, onSuccess, onError) => {
    //console.log(language_code);
    const request = axios.delete(`v1/admin/language/${language_code}`);
    return handleResponse(request, onSuccess, onError);
}

export const createLanguage = (data, onSuccess, onError) => {
    const request = axios.post(`v1/admin/language`, data);
    return handleResponse(request, onSuccess, onError);
}

export const updateLanguage = (language_code, data, onSuccess, onError) => {
    const request = axios.put(`v1/admin/language/${language_code}`, data);
    return handleResponse(request, onSuccess, onError);
}

export const softDeleteLanguage = (language_code, data, onSuccess, onError) => {
    const request = axios.put(`v1/admin/language/${language_code}/delete`, data);
    return handleResponse(request, onSuccess, onError);
} 